<template>
  <div id="app" :class="$route.name">
    <router-view />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { setup } from '@/lang'

export default {
  created() {
    this.getUserSetting()
  },
  methods: {
    ...mapMutations(['changeLang']),
    getUserSetting() {
      this.$axios({
        url: '/api/v1/client/estate/getUserSetting',
        method: 'get',
      })
        .then(res => {
          const lang = res.setting && res.setting.lang
          const _lang = lang.toLowerCase().indexOf('zh') > -1 ? 'cn' : 'en'
          setup(_lang)
          this.changeLang(_lang)
        })
        .catch(err => {
          console.error(err)
        })
    },
  },
}
</script>

<style lang="less">
@import './assets/less/fonts.less';
@import './assets/less/reset.less'; /*引入公共样式*/
@import './assets/less/element-reset.less'; /*改变element*/
@import './assets/less/common.less';
</style>

<style lang="less">
#app {
  font-family: 'Rubik', 'PingFang SC', system, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Microsoft YaHei',
    'wenquanyi micro hei', 'Hiragino Sans GB', 'Hiragino Sans GB W3', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
    'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  color: #000;
}
</style>
